import { QueryObserverBaseResult } from 'react-query'
import { Query } from '../../../hooks/queries'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import { getTeamserverUrl } from './requests/get-teamserver-url'

type UseTeamserverUrl = () => Pick<QueryObserverBaseResult, 'refetch'> & {
  isLoading: boolean
  teamserverUrl: string
}

export const useTeamserverUrl: UseTeamserverUrl = () => {
  const { data, isLoading, refetch } = useContrastQuery(
    [Query.TEAMSERVER_URL],
    getTeamserverUrl,
    {}
  )

  return {
    isLoading,
    refetch,
    teamserverUrl: !!data ? data : ''
  }
}
